// extracted by mini-css-extract-plugin
export var container = "social-link-module--container--uI6Zm";
export var dropdown = "social-link-module--dropdown--Erd88";
export var dropdownContainer = "social-link-module--dropdown-container--C-F-Q";
export var icon = "social-link-module--icon--1oorl";
export var linkItem = "social-link-module--link-item--jmLAW";